export default "__VITE_ASSET__8bcf15ee__"